<af-full-table class="w-100 h-100"
               [showImport]="false"
               [showExport]="false"
               [dataSource]="dataSource"
               [showFilter]="false"
               [showPaginator]="false"
               [sortEvent]="tableEvent.sortBy"
               (tableUpdateListener)="loadReports($event)"
               emptyStateIconName="ic_empty_state_no_data"
               emptyStateTitleTranslationKey="i18n_af_emptyStateSubtitleNoData"
               placeholderContext="analyticAgentReports">>
</af-full-table>
